import { createFileRoute, Outlet } from "@tanstack/react-router";
import { guardRoute } from "@/lib/policy/route-guard";

export const Route = createFileRoute("/_authenticated/_care/care-plan-signature-queue")({
  beforeLoad: ({ context }) => guardRoute(context.me, "care-plan-signature-queue"),
  component: Outlet,
});
